import type { ComponentType } from 'react';
import { AuthorSheetsExtractorMiniApp } from './author-sheets-extractor/AuthorSheetsExtractorMiniApp';
import { PdfSplitterMiniApp } from './pdf-splitter/PdfSplitterMiniApp';

const registry: Record<string, ComponentType> = {
  'author-sheets-extractor': AuthorSheetsExtractorMiniApp,
  'pdf-splitter': PdfSplitterMiniApp,
};

export function getMiniAppComponent(id: string): ComponentType | null {
  return registry[id] ?? null;
}
